export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_PAGE = 'LOGIN_PAGE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const OTP_RESPONSE_WAITING = 'OTP_RESPONSE_WAITING';
export const OTP_RESPONSE_RECEIVED = 'OTP_RESPONSE_RECEIVED';

export const PASSWORD_RESET_ERROR = 'PASSWORDRESET_ERROR';
export const PASSWORD_RESET_SUCCESS = 'PASSWORDRESET_SUCCESS';

export const SIGNUP_ERROR = 'SIGNUP_ERROR';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';

export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';
export const REGISTER_PAGE = 'REGISTER_PAGE';

export const MODAL_SALES_HIDE = 'MODAL_SALES_HIDE';
export const MODAL_SALES_SHOW = 'MODAL_SALES_SHOW';
export const MODAL_POLICY_HIDE = 'MODAL_POLICY_HIDE';
export const MODAL_POLICY_SHOW = 'MODAL_POLICY_SHOW';
export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';
export const MODAL_CALLBACK_SHOW = 'MODAL_CALLBACK_SHOW';
export const MODAL_CALLBACK_HIDE = 'MODAL_CALLBACK_HIDE';
export const MODAL_TYPE_CALL_ME = 'MODAL_TYPE_CALL_ME';
export const MODAL_TYPE_FNOL_CALL_ME = 'MODAL_TYPE_FNOL_CALL_ME';
export const MODAL_TYPE_SUCCESS = 'MODAL_TYPE_SUCCESS';
export const MODAL_TYPE_ERROR = 'MODAL_TYPE_ERROR';
export const MODAL_TYPE_CONFIRM_SIGN_OUT = 'MODAL_TYPE_CONFIRM_SIGN_OUT';
export const MODAL_TYPE_OK = 'MODAL_TYPE_OK';
export const MODAL_TYPE_NAM_OK = 'MODAL_TYPE_NAM_OK';
export const MODAL_TYPE_SEND_OTP = 'MODAL_TYPE_SEND_OTP';
export const MODAL_TYPE_VERIFY_OTP = 'MODAL_TYPE_VERIFY_OTP';
export const MODAL_TYPE_VERIFY_OTP_LIFE = 'MODAL_TYPE_VERIFY_OTP_LIFE';
export const MODAL_TYPE_LINK_POLICY = 'MODAL_TYPE_LINK_POLICY';
export const MODAL_TYPE_UPDATE_PROFILE = 'MODAL_TYPE_UPDATE_PROFILE';
export const MODAL_TYPE_REQUEST_DOCS = 'MODAL_TYPE_REQUEST_DOCS';
export const MODAL_TYPE_REQUEST_DOCS_COVER = 'MODAL_TYPE_REQUEST_DOCS_COVER';
export const MODAL_TYPE_REQUEST_DOCS_DATE = 'MODAL_TYPE_REQUEST_DOCS_DATE';
export const MODAL_TYPE_REQUEST_DOCS_COVER_DATE = 'MODAL_TYPE_REQUEST_DOCS_COVER_DATE';
export const MODAL_TYPE_REFER_A_FRIEND = 'MODAL_TYPE_REFER_A_FRIEND';
export const MODAL_TYPE_COMING_SOON = ' MODAL_TYPE_COMING_SOON';
export const MODAL_TYPE_BROKER_DOCS = ' MODAL_TYPE_BROKER_DOCS';
export const MODAL_TYPE_LOGIN_ERROR = 'MODAL_TYPE_LOGIN_ERROR';
export const MODAL_TYPE_QUOTE_PAYMENT = "MODAL_TYPE_QUOTE_PAYMENT";
export const MODAL_TYPE_ADD_VAP = "MODAL_TYPE_ADD_VAP";
export const MODAL_TYPE_ADD_ACCESSORRY = "MODAL_TYPE_ADD_ACCESSORRY";
export const MODAL_TYPE_ADD_CREDIT_SHORTFALL = "MODAL_TYPE_ADD_CREDIT_SHORTFALL";
export const MODAL_TYPE_ADD_VAP_CAR_HIRE = "MODAL_TYPE_ADD_VAP_CAR_HIRE";
export const MODAL_TYPE_ADD_RAFF_ASSIST = "MODAL_TYPE_ADD_RAFF_ASSIST";
export const MODAL_TYPE_INTERVENTION = "MODAL_TYPE_INTERVENTION";
export const MODAL_TYPE_ADD_NEW_QUOTE_ITEM = "MODAL_TYPE_ADD_NEW_QUOTE_ITEM";
export const MODAL_TYPE_REMOVE_QUOTE_ITEM = "MODAL_TYPE_REMOVE_QUOTE_ITEM";
export const MODAL_TYPE_SHOW_BANKING = "MODAL_TYPE_SHOW_BANKING";
export const MODAL_TYPE_SHOW_LEGAL = "MODAL_TYPE_SHOW_LEGAL";
export const MODAL_TYPE_SHOW_EDIT = "MODAL_TYPE_SHOW_EDIT";
export const MODAL_TYPE_QUOTE_ITEM_DISCARD = "MODAL_TYPE_QUOTE_ITEM_DISCARD";
export const MODAL_TYPE_REQUET_CANCELATION = "MODAL_TYPE_REQUET_CANCELATION";
export const MODAL_TYPE_REQUEST_CANCEL_LIFE_POLICY = 'MODAL_TYPE_REQUEST_CANCEL_LIFE_POLICY';
export const MODAL_TYPE_CANCEL_POLICY_EDIT = "MODAL_TYPE_CANCEL_POLICY_EDIT";
export const MODAL_TYPE_ANOTHER_SELF_INSPECTION = "MODAL_TYPE_ANOTHER_SELF_INSPECTION";
export const MODAL_TYPE_SUBMIT_SELF_INSPECTION = "MODAL_TYPE_SUBMIT_SELF_INSPECTION";
export const MODAL_DRIVABLE_NO = "MODAL_DRIVABLE_NO";
export const MODAL_TOW_ASSIST = "MODAL_TOW_ASSIST";
export const MODAL_TYPE_CHANGE_CREDIT_CARD = "MODAL_TYPE_CHANGE_CREDIT_CARD";
export const MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE = "MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE";
export const MODAL_TYPE_CONTINUE_CLAIM_ON_PHONE = "MODAL_TYPE_CONTINUE_CLAIM_ON_PHONE";
export const MODAL_TYPE_CLAIM_CONTINUE_SUCCESS = "MODAL_TYPE_CLAIM_CONTINUE_SUCCESS";
export const MODAL_TYPE_INSPECTION_CONTINUE_SUCCESS = "MODAL_TYPE_INSPECTION_CONTINUE_SUCCESS";
export const MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE_DIFFERENT = "MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE_DIFFERENT";
export const MODAL_TYPE_SELF_INSPECTION_SWITCH_TO_PHONE = "MODAL_TYPE_SELF_INSPECTION_SWITCH_TO_PHONE";
export const MODAL_TYPE_CONTINUE_INSPECTION_ON_PHONE = "MODAL_TYPE_CONTINUE_INSPECTION_ON_PHONE";
export const MODAL_TYPE_DUPLICATE_CLAIM = "MODAL_TYPE_DUPLICATE_CLAIM";
export const MODAL_TYPE_REMOVE_COVER = "MODAL_TYPE_REMOVE_COVER";
export const MODAL_TYPE_REMOVE_COVER_COMPLETE = "MODAL_TYPE_REMOVE_COVER_COMPLETE";
export const MODAL_TYPE_REMOVE_LAST_COVER = "MODAL_TYPE_REMOVE_LAST_COVER";
export const MODAL_TYPE_REMOVE_LAST_COVER_DEPENDENT_ITEMS = "MODAL_TYPE_REMOVE_LAST_COVER_DEPENDENT_ITEMS";
export const MODAL_TYPE_SHOW_EDIT_REMOVE = "MODAL_TYPE_SHOW_EDIT_REMOVE";
export const MODAL_TYPE_DRIVABLE_CLAIM_FROM_SOMEONE_ELSE = "MODAL_TYPE_DRIVABLE_CLAIM_FROM_SOMEONE_ELSE"; 
export const MODAL_TYPE_DRIVABLE_CLAIM_RECORD_PURPOSES = "MODAL_TYPE_DRIVABLE_CLAIM_RECORD_PURPOSES";
export const MODAL_TYPE_DRIVABLE_CLAIM_CLOSE_CLAIM = "MODAL_TYPE_DRIVABLE_CLAIM_CLOSE_CLAIM";
export const MODAL_TYPE_REMOVE_REASONS = "MODAL_TYPE_REMOVE_REASONS";
export const MODAL_TYPE_VIEW_INSPECTION_PHOTO ="MODAL_TYPE_VIEW_INSPECTION_PHOTO";
export const MODAL_TYPE_VIEW_POLICE_REPORT ="MODAL_TYPE_VIEW_POLICE_REPORT";
export const MODAL_TYPE_VIEW_BLACKLIST_PHONE = "MODAL_TYPE_VIEW_BLACKLIST_PHONE";
export const MODAL_TYPE_NO_LONGER_MAINLINE ="MODAL_TYPE_NO_LONGER_MAINLINE";
export const MODAL_TYPE_CLAIMS_ADDRESS_CHANGE = "MODAL_TYPE_CLAIMS_ADDRESS_CHANGE";

export const LOADING_SCREEN_SHOW = 'LOADING_SCREEN_SHOW';
export const LOADING_SCREEN_HIDE = 'LOADING_SCREEN_HIDE';
export const SALES_CHAT_LOADING_SCREEN_SHOW = 'SALES_CHAT_LOADING_SCREEN_SHOW';
export const SALES_CHAT_LOADING_SCREEN_HIDE = 'SALES_CHAT_LOADING_SCREEN_HIDE';
export const INSPECTION_PHOTO_STEP_SCREEN_SHOW = 'INSPECTION_PHOTO_STEP_SCREEN_SHOW';
export const INSPECTION_PHOTO_STEP_SCREEN_HIDE = 'INSPECTION_PHOTO_STEP_SCREEN_HIDE';
export const SELF_INSPECTION_SCREEN_SHOW = 'SELF_INSPECTION_SCREEN_SHOW';
export const SELF_INSPECTION_SCREEN_HIDE = 'SELF_INSPECTION_SCREEN_HIDE';
export const FNOL_TAKE_PHOTO_SCREEN_SHOW = 'FNOL_TAKE_PHOTO_SCREEN_SHOW';
export const FNOL_TAKE_PHOTO_SCREEN_HIDE = 'FNOL_TAKE_PHOTO_SCREEN_HIDE';
export const CLAIMSV2_TAKE_PHOTO_SCREEN_SHOW = 'CLAIMSV2_TAKE_PHOTO_SCREEN_SHOW';
export const CLAIMSV2_TAKE_PHOTO_SCREEN_HIDE = 'CLAIMSV2_TAKE_PHOTO_SCREEN_HIDE';
export const FULLSCREEN_CAMERA_SHOW = 'FULLSCREEN_CAMERA_SHOW';
export const FULLSCREEN_CAMERA_HIDE = 'FULLSCREEN_CAMERA_HIDE';
export const MAINTENANCE_SCREEN_SHOW = 'MAINTENANCE_SCREEN_SHOW';
export const MAINTENANCE_SCREEN_HIDE = 'MAINTENANCE_SCREEN_HIDE';
export const POLICY_LOAD_VIEW_SCREEN_SHOW = 'POLICY_LOAD_VIEW_SCREEN_SHOW';
export const POLICY_LOAD_VIEW_SCREEN_HIDE = 'POLICY_LOAD_VIEW_SCREEN_HIDE';
export const POLICY_VIEW_SUCCESS_SCREEN_SHOW = 'POLICY_VIEW_SUCCESS_SCREEN_SHOW';
export const POLICY_VIEW_SUCCESS_SCREEN_HIDE = 'POLICY_VIEW_SUCCESS_SCREEN_HIDE';

export const UPDATE_POLICY_LOADER_SCREEN_HIDE = 'UPDATE_POLICY_LOADER_SCREEN_HIDE';
export const UPDATE_POLICY_LOADER_SCREEN_SHOW = 'UPDATE_POLICY_LOADER_SCREEN_SHOW';
export const UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE = 'UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE';
export const UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW = 'UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW';
export const QUOTE_LOADING_SCREEN_SHOW = 'QUOTE_LOADING_SCREEN_SHOW';
export const QUOTE_LOADING_SCREEN_HIDE = 'QUOTE_LOADING_SCREEN_HIDE';

export const SET_CUSTOMER_DATA = 'SET_CUSTOMER_DATA';
export const SET_INSPECTION_ITEMS = 'SET_INSPECTION_ITEMS';
export const SET_QUOTED_FUTURE_ITEMS = 'SET_QUOTED_FUTURE_ITEMS';
export const POLICY_COVER_ITEM = 'POLICY_COVER_ITEM';
export const QUOTED_COVER_ITEM = 'QUOTED_COVER_ITEM';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const PROFILE_HIDE = 'PROFILE_HIDE';
export const PROFILE_SHOW = 'PROFILE_SHOW';

export const SET_LIFE_POLICIES = 'SET_LIFE_POLICIES';
export const SET_LIFE_POLICY = 'SET_LIFE_POLICY';
export const SET_LIFE_CONTACT = 'SET_LIFE_CONTACT';
export const SET_ACTIVE_LIFE_POLICY = 'SET_ACTIVE_LIFE_POLICY';
export const SET_LIFE_POLICY_DETAILS = 'SET_LIFE_POLICY_DETAILS';
export const SET_LIFE_COLLECTIONS = 'SET_LIFE_COLLECTIONS';
export const ADD_LIFE_COLLECTIONS = 'ADD_LIFE_COLLECTIONS';
export const SET_LIFE_COLLECTIONS_LOADING = 'SET_LIFE_COLLECTIONS_LOADING';
export const SET_LIFE_ENTITY_METADATA = 'SET_LIFE_ENTITY_METADATA';
export const UPDATE_LIFE_ENTITY_METADATA = 'UPDATE_LIFE_ENTITY_METADATA';
export const SET_LIFE_ACTIVE_BENEFIT_ID = 'SET_LIFE_ACTIVE_BENEFIT_ID';
export const SET_LIFE_ACTIVE_BENEFICIARY_ID = 'SET_LIFE_ACTIVE_BENEFICIARY_ID';
export const SET_LIFE_POLICY_DEBIT_DAY = 'SET_LIFE_POLICY_DEBIT_DAY';
export const SET_LIFE_POLICY_DEBIT_DAY_FRIENDLY = 'SET_LIFE_POLICY_DEBIT_DAY_FRIENDLY';
export const SET_LIFE_SPECIAL_DEBIT_DAYS = 'SET_LIFE_SPECIAL_DEBIT_DAYS';
export const SET_COLLECTION_TO_SCHEDULE = 'SET_COLLECTION_TO_SCHEDULE';
export const UPDATE_LIFE_CONTACT = 'UPDATE_LIFE_CONTACT';
export const UPDATE_LIFE_PREMIUM_PAYER = 'UPDATE_LIFE_PREMIUM_PAYER';
export const MODAL_TYPE_LIFE_REMOVE_BENEFICIARY = 'MODAL_TYPE_LIFE_REMOVE_BENEFICIARY';

export const UPDATE_LIFE_BENEFICIARY = 'UPDATE_LIFE_BENEFICIARY';
export const UPDATE_LIFE_POLICY_BENEFITS = 'UPDATE_LIFE_POLICY_BENEFITS';
export const SET_LIFE_NEW_BENEFICIARY = 'SET_LIFE_NEW_BENEFICIARY';
export const REMOVE_LIFE_NEW_BENEFICIARY = 'REMOVE_LIFE_NEW_BENEFICIARY';

export const SET_LIFE_BANKING_DETAILS = 'SET_LIFE_BANKING_DETAILS';
export const GET_LIFE_BANKING_DETAILS = 'GET_LIFE_BANKING_DETAILS';

export const START_NEW_SALE = 'START_NEW_SALE';
export const PRODUCT_COMPREHENSIVE_CAR = 'PRODUCT_COMPREHENSIVE_CAR';
export const PRODUCT_BLING = 'PRODUCT_BLING';
export const PRODUCT_PORTABLE_POSSESSIONS = 'PRODUCT_PORTABLE_POSSESSIONS';
export const PRODUCT_CAR_WARRANTY = 'PRODUCT_CAR_WARRANTY';
export const PRODUCT_CHILLI = 'PRODUCT_CHILLI';
export const PRODUCT_CODE_RED = 'PRODUCT_CODE_RED';
export const PRODUCT_BUILDING = 'PRODUCT_BUILDING';
export const PRODUCT_HOME_CONTENT = 'PRODUCT_HOME_CONTENT';

export const LINK_POLICYNR = 'LINK_POLICYNR';
export const LINK_IDNUMBER = 'LINK_IDNUMBER';
export const LINK_LIFE_POLICYNR = 'LINK_LIFE_POLICYNR';

export const FIELD_PHONENUMBER = 'FIELD_PHONENUMBER';
export const FIELD_ALTPHONENUMBER = 'FIELD_ALTPHONENUMBER';
export const FIELD_EMAIL = 'FIELD_EMAIL';
export const FIELD_WORKADDRESS = 'FIELD_WORKADDRESS';
export const FIELD_PREFERREDLANGUAGE = 'FIELD_PREFERREDLANGUAGE';
export const FIELD_OCCUPATION = 'FIELD_OCCUPATION';
export const FIELD_MARITALSTATUS = 'FIELD_MARITALSTATUS';

export const DOC_POLICY_SCHEDULE = 'PolicySchedule';
export const DOC_SUMMARY_OF_COVER = 'SummaryOfCover';
export const DOC_KPPD_COVER = 'KppdLetter';
export const DOC_CONFIRMATION_OF_COVER = 'ConfirmationOfCoverCar';
export const DOC_CROSS_BORDER_LETTER = 'CrossBorderLetter';
export const DOC_TAX_INVOICE = 'TaxInvoice';
export const DOC_LIFE_POLICY_DOCUMENT = 'LifePolicyDocument';

export const MODAL_DONATE = 'MODAL_DONATE';
export const MODAL_THANK_YOU = 'MODAL_THANK_YOU';

export const SET_PHOTO_DATA = 'SET_PHOTO_DATA';

export const NAVIGATE_HOME = 'NAVIGATE_HOME';
export const NAVIGATE_CLAIMS = 'NAVIGATE_CLAIMS';
export const NAVIGATE_EMERGENCY = 'NAVIGATE_EMERGENCY';
export const NAVIGATE_OTHER = 'NAVIGATE_OTHER';
export const NAVIGATE_FNOL = 'NAVIGATE_FNOL';
export const NAVIGATE_FNOL_SUBMIT_CLAIM = 'NAVIGATE_FNOL_SUBMIT_CLAIM';
export const NAVIGATE_CLAIM_HISTORY_V2 = 'NAVIGATE_CLAIM_HISTORY_V2';
export const NAVIGATE_PERSONAL_INSURANCE = 'NAVIGATE_PERSONAL_INSURANCE';
export const NAVIGATE_LIFE_INSURANCE = 'NAVIGATE_LIFE_INSURANCE';
export const NAVIGATE_PERSONAL_DETAILS = 'NAVIGATE_PERSONAL_DETAILS';
export const NAVIGATE_REQUEST_DOCUMENTS = 'NAVIGATE_REQUEST_DOCUMENTS';
export const NAVIGATE_DONATE_MY_DECREASE = 'NAVIGATE_DONATE_MY_DECREASE';
export const NAVIGATE_REFER_A_FRIEND = 'NAVIGATE_REFER_A_FRIEND';
export const NAVIGATE_MY_QUOTE = 'NAVIGATE_MY_QUOTE';
export const NAVIGATE_CONTACT_US = 'NAVIGATE_CONTACT_US';

export const SET_APP_VERSION = 'SET_APP_VERSION';
export const SET_I18N_DATA = 'SET_I18N_DATA';

export const SET_CLAIM_DATA = 'SET_CLAIM_DATA';
export const SET_QUOTE_DATA = "SET_QUOTE_DATA";
export const SET_CART_DATA = "SET_CART_DATA";
export const SET_GUEST_LOGIN_DATA = 'SET_GUEST_LOGIN_DATA';
export const SET_EXTERNAL_DATA = 'SET_EXTERNAL_DATA';

export const PAYMENT_TYPE_CREDIT = "PAYMENT_TYPE_CREDIT";
export const PAYMENT_TYPE_DEBIT = "PAYMENT_TYPE_DEBIT";

export const SET_APP_ID = "SET_APP_ID";
export const SET_SSP_DATA = "SET_SSP_DATA";

export const SET_IS_LIVIN_ENABLED = "SET_IS_LIVIN_ENABLED";
export const SET_FEATURES = "SET_FEATURES";
export const SET_SETTINGS = "SET_SETTINGS";

export const SET_IVERI_DATA = "SET_IVERI_DATA";
export const NEW_QUOTE_CAR = "NEW_QUOTE_CAR";
export const NEW_QUOTE_CODE_RED = "NEW_QUOTE_CODE_RED";
export const RESET_QUOTE_DATA = "RESET_QUOTE_DATA";
export const RESET_SELF_INSPECT_DATA = "RESET_QUOTE_DATA";
export const RESET_CART_DATA = "RESET_CART_DATA";

export const NEW_SELF_INSPECTION = "NEW_SELF_INSPECTION";
export const RESET_SELF_INSPECTION_DATA = "RESET_SELF_INSPECTION_DATA";
export const SELF_INSPECT_FRONT_SIDE = "SELF_INSPECT_FRONT";
export const SELF_INSPECT_LEFT_SIDE = "SELF_INSPECT_LEFT_SIDE";
export const SELF_INSPECT_RIGHT_SIDE = "SELF_INSPECT_RIGHT_SIDE";
export const SELF_INSPECT_BACK_SIDE = "SELF_INSPECT_BACK_SIDE";
export const SELF_INSPECT_DASHBOARD = "SELF_INSPECT_DASHBOARD";
export const SELF_INSPECT_CAR_MILEAGE_PHOTO = "SELF_INSPECT_CAR_MILEAGE_PHOTO";
export const SELF_INSPECT_CAR_MILEAGE_READING = "SELF_INSPECT_CAR_MILEAGE_READING"; 
export const SET_SELF_INSPECT_DATA = "SET_SELF_INSPECT_DATA";
export const SET_FNOL_DATA = "SET_FNOL_DATA";
export const RESET_FNOL_DATA = "RESET_FNOL_DATA";
export const RESET_CLAIM_DATA = "RESET_CLAIM_DATA";
export const SET_CLAIM_HISTORY_DATA = "SET_CLAIM_HISTORY_DATA";
export const SET_CLAIM_PROGRESS_DATA = "SET_CLAIM_PROGRESS_DATA";
export const MODAL_SWITCH_TO_MOBILE = "MODAL_SWITCH_TO_MOBILE";

export const IVERI_SUCCESS_SCREEN_SHOW = "IVERI_SUCCESS_SCREEN_SHOW";
export const IVERI_SUCCESS_SCREEN_HIDE = "IVERI_SUCCESS_SCREEN_HDIE";

export const SET_LINK_METHOD = "SET_LINK_METHOD";

export const FNOL_SELECTED_DAMAGE_CAR_SHOW = "FNOL_SELECTED_DAMAGE_CAR_SHOW";

export const MODAL_GET_BACK_TO_YOU = "MODAL_GET_BACK_TO_YOU";
export const FNOL_SELECTED_DAMAGE_CAR_HIDE = "FNOL_SELECTED_DAMAGE_CAR_HIDE";
export const FNOL_SELECTED_DAMAGE_MB_SHOW = "FNOL_SELECTED_DAMAGE_MB_SHOW";
export const CURR_CLAIMS = "FNOL";
export const MODAL_TAKE_FNOL_PHOTOS = "MODAL_TAKE_FNOL_PHOTOS";
//Styling Template
export const SET_TEMPLATE_DATA = "SET_TEMPLATE_DATA";
export const MODAL_TYPE_REFER_AGAIN = "MODAL_TYPE_REFER_AGAIN";

export const MODAL_TYPE_NOTIFICATION_SWITCH_TO_PHONE = "MODAL_TYPE_NOTIFICATION_SWITCH_TO_PHONE";
export const MODAL_TYPE_SMS_SENT = "MODAL_TYPE_NOTIFICATION_SMS_SENT";
export const MODAL_TYPE_REQUEST_A_CAR = "MODAL_TYPE_REQUEST_A_CAR";
export const MODAL_TYPE_CLAIM_ESTIMATED_TIME = "MODAL_TYPE_CLAIM_ESTIMATED_TIME";
export const MODAL_TYPE_CLAIM_ESTIMATED_TIME_EACH_STEP = "MODAL_TYPE_CLAIM_ESTIMATED_TIME_EACH_STEP";
export const MODAL_TYPE_CLAIM_COST_BREAKDOWN = "MODAL_TYPE_CLAIM_COST_BREAKDOWN";
export const MODAL_TYPE_REPAIRS_TAKING_LONGER = "MODAL_TYPE_REPAIRS_TAKING_LONGER";
export const MODAL_TYPE_GET_BACK_DAMAGE = "MODAL_TYPE_GET_BACK_DAMAGE";
export const MODAL_FNOL_NOTIFICATION_SUBMIT = "MODAL_FNOL_NOTIFICATION_SUBMIT";

export const FANCLUB_SET_DATA = "FANCLUB_SET_DATA";
export const FANCLUB_RESET_DATA = "FANCLUB_RESET_DATA";

export const MODAL_TYPE_CONFIRM_INCIDENT_AND_RISK = "MODAL_TYPE_CONFIRM_INCIDENT_AND_RISK";
export const MODAL_TYPE_ESTIMATED_DATE_CHANGED = "MODAL_TYPE_ESTIMATED_DATE_CHANGED";
export const MODAL_TYPE_CLAIM_DISCLAIMER = "MODAL_TYPE_CLAIM_DISCLAIMER";

export const CLAIM_TYPE_WARRANTY = "CLAIM_TYPE_WARRANTY";
export const CLAIM_TYPE_VAP = "CLAIM_TYPE_VAP";
export const CLAIM_TYPE_GLASS = "CLAIM_TYPE_GLASS";
export const CLAIM_TYPE_NORMAL = "CLAIM_TYPE_NORMAL";
export const CLAIM_TYPE_CELLPHONE = "CLAIM_TYPE_CELLPHONE";

export const SET_STEPS_FNOL = "SET_STEPS_FNOL";
export const SET_STEPS_GLASS = "SET_STEPS_GLASS";
export const SET_STEPS_DRIVABLE = "SET_STEPS_DRIVABLE";
export const SET_STEPS_DRIVABLE_STATIONARY = "SET_STEPS_DRIVABLE_STATIONARY";
export const SET_STEPS_CELLPHONE = "SET_STEPS_CELLPHONE";
export const SET_STEPS_CELLPHONE_OTHER = "SET_STEPS_CELLPHONE_OTHER";
export const SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE = "SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE";
export const SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE_STATIONARY = "SET_STEPS_FOLLOW_UP_MULTIPLE_VEHICLE_STATIONARY";
export const SET_STEPS_FOLLOW_UP_PEDESTRIAN = "SET_STEPS_FOLLOW_UP_PEDESTRIAN";
export const SET_STEPS_FOLLOW_UP_POTHOLE = "SET_STEPS_FOLLOW_UP_POTHOLE";
export const SET_STEPS_CODE_RED = "SET_STEPS_CODE_RED";
export const SET_STEPS_WARRANTY = "SET_STEPS_WARRANTY";
export const SET_STEPS_CLAIMS_WARRANTY = "SET_STEPS_WARRANTY";
export const SET_STEPS_BUILDING = "SET_STEPS_BUILDING";
export const SET_STEPS_HOME_CONTENT = "SET_STEPS_HOME_CONTENT";
export const SET_STEPS_BUILDING_PARTIAL = "SET_STEPS_BUILDING_PARTIAL";
export const SET_STEPS_HOME_CONTENT_PARTIAL = "SET_STEPS_HOME_CONTENT_PARTIAL";

export const MODAL_TYPE_GLASS_REPAIRS_PLEASE_NOTE = "MODAL_TYPE_GLASS_REPAIRS_PLEASE_NOTE";
export const MODAL_TYPE_CELLPHONE_PLEASE_WAIT = "MODAL_TYPE_CELLPHONE_PLEASE_WAIT";

export const MODAL_TYPE_OOPS_PORTABLE_POSSESSIONS = "MODAL_TYPE_OOPS_PORTABLE_POSSESSIONS";
export const MODAL_TYPE_PORTABLE_POSSESSIONS_REPLACEMENT_VALUE = "MODAL_TYPE_PORTABLE_POSSESSIONS_REPLACEMENT_VALUE";
export const MODAL_TYPE_QUOTE_MAINLINE_REMOVAL = "MODAL_TYPE_QUOTE_MAINLINE_REMOVAL";

export const MODAL_TYPE_CALL_BACK_REQUEST = "MODAL_TYPE_CALL_BACK_REQUEST";
export const MODAL_TYPE_SEND_IMEI_NUMBER = "MODAL_TYPE_SEND_IMEI_NUMBER";

export const MODAL_TYPE_QUOTE_SOFT_REJECTED = "MODAL_TYPE_QUOTE_SOFT_REJECTED";
export const MODAL_TYPE_QUOTE_HARD_REJECTED = "MODAL_TYPE_QUOTE_HARD_REJECTED";

export const MODAL_SIGN_IN = "MODAL_SIGN_IN";
export const MODAL_REDIRECT_NAM = "MODAL_REDIRECT_NAM";
export const MODAL_REDIRECT_ZA = "MODAL_REDIRECT_ZA";

export const EXISTING_CLIENT_ERROR = "EXISTING_CLIENT_ERROR";

export const MODAL_TYPE_POLICY_VIEW_AMENDMENTS = "MODAL_TYPE_POLICY_VIEW_AMENDMENTS";
export const MODAL_TYPE_POLICY_VIEW_AMENDMENTS_RENEWAL = "MODAL_TYPE_POLICY_VIEW_AMENDMENTS_RENEWAL";
export const PORTABLE_COVER_TYPE = "4c0cb071-42dd-4060-99ff-9f0214113458";
export const BLING_BRAND_NEW_COVER_TYPE = "D75DCDA8-A91C-4535-B17E-F7CFBB84F721";
export const BLING_LIKE_NEW_COVER_TYPE = "D75DCDA8-A91C-4535-B17E-F7CFBB84F722";
export const BLING_SCREEN_FIX_COVER_TYPE = "D75DCDA8-A91C-4535-B17E-F7CFBB84F723";
export const COMPREHENSIVE_CAR_COVER_TYPE = "4C0CB071-42DD-4060-99FF-9F0214113451";
export const AGREED_VALUE_COVER_TYPE = "4C0CB071-42DD-4060-99FF-9F0214113477";
export const THIRDPARTY_CAR_COVER_TYPE = "4C0CB071-42DD-4060-99FF-9F0214113453";
export const THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE = "4C0CB071-42DD-4060-99FF-9F0214113452";
export const THEFT_WRITEOFF_CAR_COVER_TYPE = "C2F8EE54-C2AF-4936-937F-6CD066909F3C";
export const CHILLI_CAR_COVER_TYPE = "4C0CB071-42DD-4060-99FF-9F0214113475";
export const COMPREHENSIVE_MOTORBIKE_COVER_TYPE = "0861AB66-2045-48E3-9F8A-FFBE457C4075";
export const THIRDPARTY_MOTORBIKE_COVER_TYPE = "DDD1FB41-D29C-4F77-8B8A-CA8BCE1F0FFF";
export const THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE = "786AA1B9-453F-4DF7-947D-81F3EE2218B9";
export const THEFT_MOTORBIKE_COVER_TYPE = "129C1C3D-43D4-4E7E-AB9B-440F1397EF17";

export const MODAL_CLEAR_PARTY = "MODAL_CLEAR_PARTY";
export const MODAL_TYPE_CLICK_AWAY = "MODAL_TYPE_CLICK_AWAY";
export const THIRDPARTY_TYPE_OTHER = "THIRDPARTY_TYPE_OTHER";
export const THIRDPARTY_TYPE_WITNESS = "THIRDPARTY_TYPE_WITNESS";
export const THIRDPARTY_TYPE_PEDESTRIAN = "THIRDPARTY_TYPE_PEDESTRIAN";
export const THIRDPARTY_TYPE_PASSENGER = "THIRDPARTY_TYPE_PASSENGER";
export const THIRDPARTY_TYPE_OTHER_ID = 12;

export const CLAIM_DAMAGE_CAUSE_ANIMAL = 34;
export const CLAIM_DAMAGE_CAUSE_POTHOLE = 35;
export const CLAIM_DAMAGE_CAUSE_PEDESTRIAN = 36;
export const CLAIM_DAMAGE_CAUSE_SINGLE_VEHICLE_STATIONARY = 38;
export const CLAIM_DAMAGE_CAUSE_MULTI_VEHICLE_STATIONARY = 38;
export const CLAIM_DAMAGE_CAUSE_SINGLE_VEHICLE_DRIVEN = 49;
//!!Not used yet: CLAIM_DAMAGE_CAUSE_MULTI_VEHICLE_DRIVEN
export const CLAIM_DAMAGE_CAUSE_TYRE_BURST = 33;
export const CLAIM_DAMAGE_CAUSE_TRACK_INCIDENT = 51;

export const CLAIM_INCIDENT_TYPE_ANIMAL = 12;
export const CLAIM_INCIDENT_TYPE_POTHOLE = 11;
export const CLAIM_INCIDENT_TYPE_PEDESTRIAN = 676;
export const CLAIM_INCIDENT_TYPE_SINGLE_VEHICLE_STATIONARY = 25;
export const CLAIM_INCIDENT_TYPE_MULTI_VEHICLE_STATIONARY = 558;
export const CLAIM_INCIDENT_TYPE_SINGLE_VEHICLE_DRIVEN = 14;
//!!Not used yet: CLAIM_INCIDENT_TYPE_MULTI_VEHICLE_DRIVEN = 13;
export const CLAIM_INCIDENT_TYPE_TYRE_BURST = 21;
export const CLAIM_INCIDENT_TYPE_TRACK_INCIDENT_MOTOR = 718;
export const CLAIM_INCIDENT_TYPE_TRACK_INCIDENT_MOTORBIKE = 707;

export const ThirdPartyConfigurations = [
    {
        thirdPartyConfigType: THIRDPARTY_TYPE_OTHER,
        firstName: true,
        firstNameValidation: true,
        surname: true,
        surnameValidation: false,
        contactNumber: true,
        contactNumberValidation: false,
        email: true,
        emailValidation: false,
        contactNumberOrEmailValidation: true,
        idNumber: true,
        idNumberValidation: false,
        registrationNumber: true,
        registrationNumberValidation: true,
        vehicleDescription: true,
        vehicleDescriptionValidation: false,
        vehicleDamageDescription: true,
        vehicleDamageDescriptionValidation: false,
        hasInsurance: true,
        hasInsuranceValidation: false,
        headerText: "Party",
        addText: "another party involved",
    },
    {
        thirdPartyConfigType: THIRDPARTY_TYPE_PASSENGER,
        firstName: true,
        firstNameValidation: true,
        surname: true,
        surnameValidation: false,
        contactNumber: true,
        contactNumberValidation: true,
        email: false,
        emailValidation: false,
        contactNumberOrEmailValidation: false,
        idNumber: false,
        idNumberValidation: false,
        registrationNumber: false,
        registrationNumberValidation: false,
        vehicleDescription: false,
        vehicleDescriptionValidation: false,
        vehicleDamageDescription: false,
        vehicleDamageDescriptionValidation: false,
        hasInsurance: false,
        hasInsuranceValidation: false,
        headerText: "Passenger",
        addText: "passenger"
    },
    {
        thirdPartyConfigType: THIRDPARTY_TYPE_PEDESTRIAN,
        firstName: true,
        firstNameValidation: true,
        surname: true,
        surnameValidation: false,
        contactNumber: true,
        contactNumberValidation: false,
        email: true,
        emailValidation: false,
        contactNumberOrEmailValidation: true,
        idNumber: true,
        idNumberValidation: false,
        registrationNumber: false,
        registrationNumberValidation: false,
        vehicleDescription: false,
        vehicleDescriptionValidation: false,
        vehicleDamageDescription: false,
        vehicleDamageDescriptionValidation: false,
        hasInsurance: false,
        hasInsuranceValidation: false,
        headerText: "Pedestrian",
        addText: "pedestrian",
    },
    {
        thirdPartyConfigType: THIRDPARTY_TYPE_WITNESS,
        firstName: true,
        firstNameValidation: true,
        surname: true,
        surnameValidation: false,
        contactNumber: true,
        contactNumberValidation: false,
        email: false,
        emailValidation: false,
        contactNumberOrEmailValidation: false,
        idNumber: false,
        idNumberValidation: false,
        registrationNumber: false,
        registrationNumberValidation: false,
        vehicleDescription: false,
        vehicleDescriptionValidation: false,
        vehicleDamageDescription: false,
        vehicleDamageDescriptionValidation: false,
        hasInsurance: false,
        hasInsuranceValidation: false,
        headerText: "Witness",
        addText: "witness",
    },
];

export const CAR_NIGHT_PARKING_LOCATION_ID = 6;
export const INCIDENT_LOCATION_ID = 1;
export const CLAIM_OCCURANCE_AT_HOME = 1;
export const CLAIM_OCCURANCE_AWAY_FROM_HOME = 2;

export const KPPORTAL_QUOTE_SOURCE = 3;
export const LIMITED_UNDERWRITING_SOURCE = 2;

export const CONFIRMATION_OF_COVER_MOTORBIKE = "500";
export const CROSS_BORDER_MOTORBIKE = "938";
export const CROSS_BORDER_CAR = "6";

export const CLAIM_THIRD_PARTY_INSURED_YES = 1;
export const CLAIM_THIRD_PARTY_INSURED_NO = 2;
export const CLAIM_THIRD_PARTY_INSURED_NOT_SURE = 3;

export const CLAIM_SCRATCH_AND_DENT_TEMPLATE_ID = 993;
export const CLAIM_TYRE_AND_RIM_TEMPLATE_ID = 994;
export const CLAIM_LITTLE_DINGS_TEMPLATE_ID = 995;
export const CLAIM_WARRANTY_TEMPLATE_ID = 996;

export const BUILDING_USAGE_RUNNING_BUSINESS_ID = 1;
export const BUILDING_USAGE_PRIVATE_ID = 3;
export const BUILDING_USAGE_HOLIDAY_ID = 6;
export const BUILDING_USAGE_RENTING_INCOME_ID = 8;

export const BUILDING_OCCUPANT_OWNER_ID = 1;
export const BUILDING_OCCUPANT_TENNANT_ID = 5;
export const BUILDING_OCCUPANT_STORAGE_ID = 6;

export const BUILDING_BORDER_FIELD_ID = 1;
export const BUILDING_BORDER_RIVER_ID = 2;
export const BUILDING_BORDER_INFORMAL_ID = 3;
export const BUILDING_BORDER_PLOT_ID = 4;

export const BUILDING_FINISH_STANDARD_ID = 1;
export const BUILDING_FINISH_ABOVE_AVERAGE_ID = 2;
export const BUILDING_FINISH_HIGH_ID = 3;

export const BUILDING_CLAIM_TYPE_ID = 5;
export const CONTENT_CLAIM_TYPE_ID = 4;

export const BUILDING_UNKNOWN_INSURER = 75;

export const ACTIVE_POLICY = 3;
export const CANCELLED_POLICY = 4;

export const EXTERNAL_LOGIN = 'EXTERNAL_LOGIN';

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
